const DescriptionComponent = ({ description }) => {
  return (
    <span id="ellipsis-ex" class="d-inline-block text-truncate" style={{ maxWidth: "150px" }} title={description}>
      {description || "Unknown"}
    </span>
  );
};

export default DescriptionComponent;
